module.exports = __webpack_public_path__ + "media/test/step_2-ecab4f30.png";